(function () {
  'use strict';

  var section = document.querySelector('[data-section-type="product"]');
  if (!section) return;

  /* ---------- Description: table scroll wrappers and section accordions ---------- */
  var desc = section.querySelector('.isc-desc');

  if (desc) {
    Array.prototype.forEach.call(desc.querySelectorAll('table'), function (table) {
      var wrap = document.createElement('div');
      wrap.className = 'isc-table-wrap';
      table.parentNode.insertBefore(wrap, table);
      wrap.appendChild(table);
    });

    var pickHeadings = function () {
      var kids = Array.prototype.slice.call(desc.children);
      var byTag = function (tag) { return kids.filter(function (el) { return el.tagName === tag; }); };
      var h2 = byTag('H2');
      if (h2.length >= 2) return h2;
      var h3 = byTag('H3');
      return h3.length >= 2 ? h3 : [];
    };

    pickHeadings().forEach(function (heading, index) {
      var tag = heading.tagName;
      var details = document.createElement('details');
      var summary = document.createElement('summary');
      var body = document.createElement('div');
      details.className = 'isc-acc';
      body.className = 'isc-acc__body';
      heading.parentNode.insertBefore(details, heading);
      summary.appendChild(heading);
      details.appendChild(summary);
      details.appendChild(body);

      while (details.nextElementSibling && details.nextElementSibling.tagName !== tag) {
        body.appendChild(details.nextElementSibling);
      }

      /* The first section and any specifications start open */
      details.open = index === 0 || !!body.querySelector('table') || /spec|technical/i.test(heading.textContent);
    });
  }

  /* ---------- Description: section navigation on desktop, accordions on phones ---------- */
  if (desc) {
    var sections = Array.prototype.slice.call(desc.querySelectorAll(':scope > .isc-acc'));
    var wide = window.matchMedia('(min-width: 1000px)');
    var openForWidth = function () {
      if (wide.matches) sections.forEach(function (item) { item.open = true; });
    };
    openForWidth();
    wide.addEventListener('change', openForWidth);

    var navHeadings = Array.prototype.slice.call(desc.querySelectorAll('h2'));
    if (navHeadings.length < 3) navHeadings = Array.prototype.slice.call(desc.querySelectorAll('h3'));

    if (navHeadings.length >= 3) {
      var nav = document.createElement('nav');
      nav.className = 'isc-nav';
      nav.setAttribute('aria-label', 'Product information');
      var links = navHeadings.map(function (heading, index) {
        heading.id = heading.id || 'isc-section-' + (index + 1);
        heading.classList.add('isc-anchor');
        var link = document.createElement('a');
        link.href = '#' + heading.id;
        link.textContent = heading.textContent.trim().replace(/:$/, '');
        link.addEventListener('click', function (event) {
          event.preventDefault();
          var holder = heading.closest('details');
          if (holder) holder.open = true;
          heading.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
        nav.appendChild(link);
        return link;
      });
      var grid = document.createElement('div');
      grid.className = 'isc-desc-grid';
      desc.parentNode.insertBefore(grid, desc);
      grid.appendChild(nav);
      grid.appendChild(desc);

      if ('IntersectionObserver' in window) {
        var spy = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            links.forEach(function (link, index) {
              link.classList.toggle('is-active', navHeadings[index] === entry.target);
            });
          });
        }, { rootMargin: '-15% 0px -70% 0px' });
        navHeadings.forEach(function (heading) { spy.observe(heading); });
      }
    }
  }

  /* ---------- Variant changes: gallery image, stock line, basket bar ---------- */
  var stockLine = section.querySelector('.isc-stock');

  var showVariantImage = function (variant) {
    if (!variant || !variant.featured_media) return;
    var id = variant.featured_media.id;
    var thumb = section.querySelector('a.product-gallery__thumbnail[data-media-id="' + id + '"]');
    if (!thumb || thumb.classList.contains('is-nav-selected')) return;
    var stopNavigation = function (event) { event.preventDefault(); };
    thumb.addEventListener('click', stopNavigation, { once: true });
    thumb.click();
  };

  /* ---------- Delivery estimate: 2pm UK cut-off, Monday to Friday, then 2 working days ---------- */
  var etaLine = section.querySelector('[data-isc-eta]');
  var etaAllowed = !!etaLine;
  var CUT_OFF_MINUTES = 14 * 60;
  /* England and Wales, from gov.uk/bank-holidays.json. The estimate switches itself off after the last date. */
  var BANK_HOLIDAYS = ['2026-12-25', '2026-12-28', '2027-01-01', '2027-03-26', '2027-03-29', '2027-05-03', '2027-05-31', '2027-08-30', '2027-12-27', '2027-12-28', '2028-01-03', '2028-04-14', '2028-04-17', '2028-05-01', '2028-05-29', '2028-08-28', '2028-12-25', '2028-12-26'];

  /* A product whose own description states a different lead time keeps that wording only */
  if (desc && /(deliver|dispatch|lead)[^.]{0,40}\d+\s*(?:-|–|to)\s*\d+\s*(?:working|business)?\s*(?:days?|weeks?)/i.test(desc.textContent)) {
    etaAllowed = false;
  }

  var ukNow = function () {
    var parts = {};
    new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/London', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23'
    }).formatToParts(new Date()).forEach(function (part) { parts[part.type] = parseInt(part.value, 10); });
    return {
      date: new Date(Date.UTC(parts.year, parts.month - 1, parts.day)),
      seconds: parts.hour * 3600 + parts.minute * 60 + parts.second
    };
  };
  var isWorkingDay = function (date) {
    var day = date.getUTCDay();
    return day !== 0 && day !== 6 && BANK_HOLIDAYS.indexOf(date.toISOString().slice(0, 10)) === -1;
  };
  var addWorkingDays = function (date, count) {
    var next = new Date(date.getTime());
    while (count > 0) {
      next.setUTCDate(next.getUTCDate() + 1);
      if (isWorkingDay(next)) count -= 1;
    }
    return next;
  };

  var renderEta = function (available) {
    if (!etaLine) return;
    var now = ukNow();
    var beforeCutOff = isWorkingDay(now.date) && now.seconds < CUT_OFF_MINUTES * 60;
    var dispatch = beforeCutOff ? now.date : addWorkingDays(now.date, 1);
    var delivery = addWorkingDays(dispatch, 2);

    if (!etaAllowed || !available || delivery.toISOString().slice(0, 10) > BANK_HOLIDAYS[BANK_HOLIDAYS.length - 1]) {
      etaLine.hidden = true;
      return;
    }

    var dateText = new Intl.DateTimeFormat('en-GB', { timeZone: 'UTC', weekday: 'long', day: 'numeric', month: 'long' }).format(delivery);
    var lead = 'Order now';
    if (beforeCutOff) {
      var minutes = Math.max(1, Math.ceil((CUT_OFF_MINUTES * 60 - now.seconds) / 60));
      var hours = Math.floor(minutes / 60);
      var left = minutes % 60;
      lead = 'Order within ' + (hours ? hours + (hours === 1 ? ' hr ' : ' hrs ') : '') + (left || !hours ? left + (left === 1 ? ' min' : ' mins') : '').trim();
    }
    etaLine.textContent = '';
    var strong = document.createElement('strong');
    strong.textContent = dateText;
    etaLine.appendChild(document.createTextNode(lead.trim() + ' for estimated delivery by '));
    etaLine.appendChild(strong);
    etaLine.hidden = false;
  };

  var variantAvailable = !!section.querySelector('.product-form__add-button:not([disabled])');
  renderEta(variantAvailable);
  setInterval(function () { renderEta(variantAvailable); }, 30000);

  /* ---------- Option buttons show what each choice costs ---------- */
  var productJson = section.querySelector('[data-product-json]');
  var productData = productJson ? JSON.parse(productJson.textContent).product : null;
  var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'GBP';
  var money = function (pence) {
    return new Intl.NumberFormat('en-GB', { style: 'currency', currency: currency }).format(pence / 100);
  };
  var unitOf = function (value) {
    var match = /^(\d+(?:\.\d+)?)\s*(l|lt|ltr|litres?|kgs?)\b/i.exec(value);
    if (!match || !parseFloat(match[1]) || parseFloat(match[1]) === 1) return null;
    return { size: parseFloat(match[1]), label: /^k/i.test(match[2]) ? 'kg' : 'L' };
  };

  var showChipPrices = function () {
    if (!productData || productData.variants.length < 2) return;

    var options = Array.prototype.slice.call(section.querySelectorAll('.product-form__option[data-selector-type="block"]'));
    var chosen = {};
    options.forEach(function (option) {
      var radio = option.querySelector('.block-swatch__radio:checked');
      if (radio) chosen[radio.getAttribute('data-option-position')] = radio.value;
    });

    options.forEach(function (option) {
      var radios = Array.prototype.slice.call(option.querySelectorAll('.block-swatch__radio'));
      if (radios.length < 2 || radios.length > 12) return;

      var prices = radios.map(function (radio) {
        var position = radio.getAttribute('data-option-position');
        var match = productData.variants.filter(function (variant) {
          return Object.keys(chosen).every(function (key) {
            return (key === position ? radio.value : chosen[key]) === variant['option' + key];
          });
        })[0];
        return match ? match.price : null;
      });
      var distinct = prices.filter(function (price, index) { return price !== null && prices.indexOf(price) === index; });

      radios.forEach(function (radio, index) {
        var text = radio.parentNode.querySelector('.block-swatch__item-text');
        var tag = text.querySelector('.isc-chip-price');
        if (distinct.length < 2 || prices[index] === null) {
          if (tag) tag.remove();
          return;
        }
        if (!tag) {
          tag = document.createElement('span');
          tag.className = 'isc-chip-price';
          text.appendChild(tag);
        }
        var unit = unitOf(radio.value);
        tag.textContent = money(prices[index]);
        if (unit) {
          var perUnit = document.createElement('span');
          perUnit.className = 'isc-chip-unit';
          perUnit.textContent = ' (' + money(prices[index] / unit.size) + '/' + unit.label + ')';
          tag.appendChild(perUnit);
        }
      });
    });
  };

  showChipPrices();

  /* ---------- Sticky basket bar ---------- */
  var bar = document.getElementById('isc-bar');
  var addButton = section.querySelector('.product-form__add-button');
  var syncBar = function () {};

  if (bar && addButton) {
    var barPrice = bar.querySelector('[data-isc-bar-price]');
    var barVariant = bar.querySelector('[data-isc-bar-variant]');
    var barButton = bar.querySelector('.isc-bar__btn');
    var barThumb = bar.querySelector('.isc-bar__thumb');
    var outOfView = false;

    var render = function () {
      var on = outOfView && !addButton.disabled;
      bar.classList.toggle('is-on', on);
      document.body.classList.toggle('isc-bar-on', on);
    };

    syncBar = function (variant) {
      var price = section.querySelector('.price-list .price');
      if (price && barPrice) {
        var clone = price.cloneNode(true);
        Array.prototype.forEach.call(clone.querySelectorAll('.visually-hidden'), function (el) { el.remove(); });
        barPrice.textContent = clone.textContent.trim();
      }
      if (variant && barVariant) barVariant.textContent = variant.title === 'Default Title' ? '' : variant.title;
      if (variant && variant.featured_image && barThumb) barThumb.src = variant.featured_image.src.replace(/(\.[a-z]+)(\?|$)/i, '_96x96_crop_center$1$2');
      render();
    };

    barButton.addEventListener('click', function () { addButton.click(); });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        /* Keeps a buy button on screen whenever the main one is out of view, above or below */
        outOfView = !entries[entries.length - 1].isIntersecting;
        render();
      }).observe(addButton);
    }

    syncBar();
  }

  section.addEventListener('variant:changed', function (event) {
    var variant = event.detail.variant;
    if (stockLine) stockLine.hidden = !(variant && variant.available);
    variantAvailable = !!(variant && variant.available);
    renderEta(variantAvailable);
    showVariantImage(variant);
    showChipPrices();
    syncBar(variant);
  });
})();
